export default __webpack_public_path__ + "static/media/ErrorUnSuccess.30198d23.svg";